import { connect } from 'react-redux'
import { getHasActiveVehicleStatus } from 'selectors'
import Records from './Records'

const mapStateToProps = state => ({
  hasActiveVehicle: getHasActiveVehicleStatus(state)
})

export default connect(mapStateToProps)(Records)
